module.exports = __webpack_public_path__ + "img/hyper.ecfe53b6.jpg";